import { closeModal } from '@/helpers/closeModal';

export const closeButtonClickAction = () => {
  const closeButtonElement = document.querySelector('.storeeel-menu-area-icons .cross-close-button-parent');
  closeButtonElement.addEventListener('click', () => {
    closeModal();
  });
};
